export default __webpack_public_path__ + "static/media/timor_icon.98f18879.svg";